import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import i18n from "@/i18n";
import vuetify from "./plugins/vuetify";
import initializeVeeValidate from "@/plugins/vee-validate";
import InlineSvg, { InlineSvgPlugin } from "vue-inline-svg";

Vue.config.productionTip = process.env.NODE_ENV === "development";

initializeVeeValidate();

Vue.use(InlineSvgPlugin);
Vue.component("inline-svg", InlineSvg);

declare global {
  interface Window {
    dtrum: any;
  }
}

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
